<template>
  <div class="bg-white rounded-lg" v-if="informacion_empresa_props.numero_nit">
    <div class="divide-y divide-separatorColor mx-4 pt-4">
      <p class="font-bold text-xl pb-3.5">Información de la empresa</p>
      <p></p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mx-4 pt-5">
      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <label>
          {{ this.idTipoPersona === 1 || this.informacion_empresa.numero_nit.value.length <=10 ? 'Documento Único de Identidad (DUI)' : 'Número de Identificación Tributaria (NIT)' }}
        </label>
        <!-- placeholder="0000-000000-000-0" -->
        <input type="text" @change="setLocalStorage_(1)" v-model="informacion_empresa.numero_nit.value"
          
          class="block w-full py-1.5 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-300 focus:border-blue-500"
          :class="informacion_empresa.numero_nit.state === true ? 'border-red-500' : ''" required disabled />
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          v-if="informacion_empresa.numero_nit.state === true">
          {{ informacion_empresa.numero_nit.message }}
        </span>
      </div>
      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <label class="">
          Escaneo de  {{ this.idTipoPersona === 1 || this.informacion_empresa.numero_nit.value.length <=10 ? 'Documento Único de Identidad (DUI)' : 'Número de Identificación Tributaria (NIT)' }}*
          <span class="cursor-pointer text-primary underline" @click="download(InfoEmpresa.nit_doc)"
            v-if="informacion_empresa.foto_nit.value !== null">
            <font-awesome-icon icon="download" class="pr-1"></font-awesome-icon><strong>Descargar documento</strong>
          </span>
        </label>

        <div>
          <label
            class="inline-flex items-center block w-full py-1 px-3 mt-2 rounded-md appearance-none focus:outline-none focus:border-gray-200 border-gray-400 border"
            :class="informacion_empresa_props.foto_nit.state === true && informacion_empresa.foto_nit.value == null && (this.$route.params.id) !== 'proceso' ? 'focus:border-red-500 border-red-500 border' : 'focus:border-gray-200 border-gray-400 border'">
            <font-awesome-icon icon="paperclip"></font-awesome-icon>
            <span class="pl-3 text-base leading-normal py-0.5" v-if="fotonit == null && fotoNit.length === 0">
              {{ informacion_empresa.foto_nit.value !== null ? 'Volver' : 'Selecciona el archivo' }} a subir
            </span>
            <span class="pl-3 text-base leading-normal py-0.5" v-else-if="fotonit !== null">
              <badges v-model="fotonit"></badges>
            </span>
            <span class="pl-3 text-base leading-normal py-0.5" v-else>
              <badges value="archivo ya cargado" color="info"></badges>
            </span>
            <input type='file' class="hidden" @change="fotonit_($event.target.files[0])" />
          </label>
        </div>
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          v-if="informacion_empresa_props.foto_nit.state === true && informacion_empresa.foto_nit.value == null && (this.$route.params.id) !== 'proceso'">
          {{ informacion_empresa_props.foto_nit.message }}
        </span>
      </div>

      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <label>Número de Registro de Contribuyente (NRC) *</label>
        <input type="text" @change="setLocalStorage_(1)" v-model="informacion_empresa.numero_registro.value"
          placeholder="0000-0"
          class="block w-full py-1.5 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-300 focus:border-blue-500"
          :class="informacion_empresa.numero_registro.state === true ? 'border-red-500' : ''"
          @input="changeMask($event.target.value)" v-mask="maskara" required />
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          v-if="informacion_empresa_props.numero_registro.state === true">
          {{ informacion_empresa_props.numero_registro.message }}
        </span>
      </div>
      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <label>
          Escaneo de Número de Registro de Contribuyente (NRC) *
          <span class="cursor-pointer text-primary underline" @click="download(InfoEmpresa.nrc_doc)"
            v-if="informacion_empresa.foto_numero_registro.value !== null">
            <font-awesome-icon icon="download" class="pr-1"></font-awesome-icon><strong>Descargar documento</strong>
          </span>
        </label>
        <div>
          <label
            class="inline-flex items-center block w-full py-1 px-3 mt-2 rounded-md appearance-none focus:outline-none focus:border-gray-200 border-gray-400 border"
            :class="informacion_empresa_props.foto_numero_registro.state === true && informacion_empresa.foto_numero_registro.value == null && (this.$route.params.id) !== 'proceso' ? 'focus:border-red-500 border-red-500 border' : 'focus:border-gray-200 border-gray-400 border'">
            <font-awesome-icon icon="paperclip"></font-awesome-icon>
            <span class="pl-3 text-base leading-normal py-0.5" v-if="fotornc == null && fotoRnc.length === 0">
              {{
                informacion_empresa.foto_numero_registro.value != null ? 'Volver' : 'Selecciona el archivo'
              }} a subir</span>
            <span class="pl-3 text-base leading-normal py-0.5" v-else-if="fotornc !== null">
              <badges v-model="fotornc"></badges>
            </span>
            <span class="pl-3 text-base leading-normal py-0.5" v-else>
              <badges value="archivo ya cargado" color="info"></badges>
            </span>
            <input type='file' class="hidden" @change="fotornc_($event.target.files[0])" />
          </label>
        </div>
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          v-if="informacion_empresa_props.foto_numero_registro.state === true && informacion_empresa.foto_numero_registro.value == null && (this.$route.params.id) !== 'proceso'">
          {{ informacion_empresa_props.foto_numero_registro.message }}
        </span>
      </div>


      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <label>Nombre o razón social *</label>
        <input type="text" v-model="informacion_empresa.nombre_empresa.value"
          @change="(setLocalStorage_(1), validData('nombre_empresa'))" placeholder="Nombre de empresa"
          class="block w-full py-1.5 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-300 focus:border-blue-500"
          :class="informacion_empresa_props.nombre_empresa.state === true ? 'border-red-500' : ''" required />
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          v-if="informacion_empresa_props.nombre_empresa.state === true">
          {{ informacion_empresa_props.nombre_empresa.message }}
        </span>
      </div>
      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <label>Nombre comercial</label>
        <input type="text" v-model="informacion_empresa.nombre_comercial_empresa.value"
          placeholder="Nombre comercial de la empresa"
          @change="(setLocalStorage_(1), validData('nombre_comercial_empresa'))"
          class="block w-full py-1.5 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-300 focus:border-blue-500"
          :class="informacion_empresa_props.nombre_comercial_empresa.state === true ? 'border-red-500' : ''" />
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          v-if="informacion_empresa_props.nombre_comercial_empresa.state === true">
          {{ informacion_empresa_props.nombre_comercial_empresa.message }}
        </span>
      </div>
      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <SelectComponent label="País de la empresa" :options="pais_origen_options" :placeholder="informacion_empresa.pais_origen_empresa.name !== null
          && this.informacion_empresa.pais_origen_empresa.value !== null
          ? informacion_empresa.pais_origen_empresa.name : 'Seleccionar'" input-value="id" input-label="nombre"
          v-model:value="pais" :error-message="informacion_empresa_props.pais_origen_empresa.message" :state="informacion_empresa_props.pais_origen_empresa.state === null
            ? null : !informacion_empresa_props.pais_origen_empresa.state" required disabled></SelectComponent>
      </div>




      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <SelectComponent label="Tipo de personería" :options="tipo_personeria_options" :placeholder="informacion_empresa.tipo_personeria.name !== null
          && this.informacion_empresa.tipo_personeria.value !== null
          ? informacion_empresa.tipo_personeria.name : 'Seleccionar'" input-value="id" input-label="nombre"
          v-model:value="tipopersoneria" :error-message="informacion_empresa_props.tipo_personeria.message" :state="informacion_empresa_props.tipo_personeria.state === null
            ? null : !informacion_empresa_props.tipo_personeria.state" required disabled ></SelectComponent>
      </div>

      <!-- disabled -->




      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <label>Número de matrícula de comercio {{ requiredLicense }}</label>
        <input type="text" v-model="informacion_empresa.numero_matricula_comercial.value"
          placeholder="Matricula comercial" @change="(setLocalStorage_(1), validData('numero_matricula_comercial'))"
          class="block w-full py-1.5 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-300 focus:border-blue-500"
          :class="informacion_empresa_props.numero_matricula_comercial.state === true ? 'border-red-500' : ''" />
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          v-if="informacion_empresa_props.numero_matricula_comercial.state === true">
          {{ informacion_empresa_props.numero_matricula_comercial.message }}
        </span>
      </div>
      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1 ">
        <SelectComponent label="Clasificación de empresa" :options="tamano_empresa_options" input-value="id"
          input-label="nombre" v-model:value="tamanio" :error-message="informacion_empresa_props.tamano_empresa.message"
          :state="informacion_empresa_props.tamano_empresa.state === null
            ? null : !informacion_empresa_props.tamano_empresa.state" required></SelectComponent>
      </div>
      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <label>Ventas del ultimo año *</label>
        <input type="number" placeholder="Ventas del ultimo año" @keypress="restrictDecimal($event)"
          @change="(setLocalStorage_(1), validData('sales'))" v-model="informacion_empresa.sales.value"
          class="block w-full py-1.5 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-300 focus:border-blue-500"
          :class="informacion_empresa_props.sales.state === true ? 'border-red-500' : ''" min="0" />
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          v-if="informacion_empresa_props.sales.state === true">
          {{ informacion_empresa_props.sales.message }}
        </span>
      </div>
      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <label>Años de experiencia *</label>
        <input type="number" placeholder="experiencia" @change="(setLocalStorage_(1), validData('experiencia'))"
          v-model="informacion_empresa.experiencia.value"
          class="block w-full py-1.5 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-300 focus:border-blue-500"
          onkeydown="return event.keyCode === 8 ||
                                event.keyCode === 46 ? true : !isNaN(Number(event.key))"
          :class="informacion_empresa_props.experiencia.state === true ? 'border-red-500' : ''" min="0" />
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          v-if="informacion_empresa_props.experiencia.state === true">
          {{ informacion_empresa_props.experiencia.message }}
        </span>
      </div>
      <div class="col-span-2 grid grid-cols-3">
        <div class="sm:col-span-3 md:col-span-3 xs:col-span-3 lg:col-span-3">
          <label>Actividad económica o giros de la empresa *</label>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
            v-if="informacion_empresa_props.giros.state === true">
            {{ informacion_empresa_props.giros.message }}
          </span>
        </div>
        <div class="sm:col-span-2 md:col-span-2 xs:col-span-2 lg:col-span-2">
          <SelectComponent label="" :options="giro_options" input-value="id" input-label="nombre" v-model:value="giro">
          </SelectComponent>
        </div>
        <div class="ml-3 mt-2">
          <button type="button" @click="aggGiros(null)"
            class="px-5 py-2 focus:outline-none text-white bg-blue-500 hover:bg-blue-600 rounded-md">
            <font-awesome-icon icon="plus" class="text-white"></font-awesome-icon>
            Agregar
          </button>
        </div>
      </div>
      <div class="xl:col-span-2 sm:col-span-2 md:col-span-2 xs:col-span-2 lg:col-span-2 pr-6">
        <tablecomponent :items="informacion_empresa.giros.value" :fields="fieldsGiro">
          <!--            :fields="fieldsGiro" :show-index="true">-->
          <template v-slot:accion="row">
            <button class="py-1 text-white bg-white focus:outline-none rounded-md"
              @click="aggGiros(row.item, row.item.id)">
              <font-awesome-icon icon="trash" class="text-primary"></font-awesome-icon>
            </button>
          </template>
        </tablecomponent>
      </div>
    </div>

    <div class="divide-y divide-separatorColor px-4 pt-10">
      <p class="font-bold text-xl text-textHead pb-3.5">Ubicación</p>
      <p></p>
    </div>
    <div class="grid grid-cols-2 gap-4 px-4 pt-5">
      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <SelectComponent label="Departamento" :options="departamento_options" :placeholder="ubicacion.departamento.name !== null &&
          this.ubicacion.departamento.value !== null
          ? ubicacion.departamento.name : 'Seleccionar'" input-value="id" input-label="nombre"
          v-model:value="departamento" :error-message="ubicacion_props.departamento.message" :state="ubicacion_props.departamento.state === null
            ? null : !ubicacion_props.departamento.state" required></SelectComponent>

      </div>
      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <SelectComponent label="Municipio" :options="municipio_options" :placeholder="ubicacion.municipio.name !== null &&
          this.ubicacion.municipio.value !== null
          ? ubicacion.municipio.name : 'Seleccionar'" input-value="id" input-label="nombre" v-model:value="municipio"
          :error-message="ubicacion_props.municipio.message" :state="ubicacion_props.municipio.state === null
            ? null : !ubicacion_props.municipio.state" required></SelectComponent>
      </div>
      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <label>Dirección *</label>
        <input type="text" v-model="ubicacion.direccion.value" placeholder="Dirección"
          @change="(setLocalStorage_(2), validData('direccion'))"
          class="block w-full py-1.5 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-300 focus:border-blue-500"
          :class="ubicacion_props.direccion.state === true ? 'border-red-500' : ''" required />
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          v-if="ubicacion_props.direccion.state === true">
          {{ ubicacion_props.direccion.message }}
        </span>
      </div>
    </div>

    <!--Datos de contacto-->
    <div class="divide-y divide-separatorColor px-4 pt-10">
      <p class="font-bold text-xl text-textHead pb-3.5">Datos de contacto</p>
      <p></p>
    </div>
    <div class="grid grid-cols-2 gap-4 px-4 pt-5">
      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <label>Correo electrónico de la empresa*</label>
        <input type="email" v-model="dato_contacto.correo_empresa.value" placeholder="Correo electrónico"
          @change="(setLocalStorage_(3), isEmailValid(), validData('correo_empresa'))"
          class="block w-full py-1.5 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-300 focus:border-blue-500"
          required />
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          v-if="dato_contacto_props.correo_empresa.state === true">
          {{ dato_contacto_props.correo_empresa.message }}
        </span>
        <span class="flex items-center font-medium tracking-wide text-red-700 text-xs mt-1 ml-1"
          v-if="informacion_empresa_props.isValidEmail === false">
          ***{{ informacion_empresa_props.isValidEmailmessage }}***
        </span>
      </div>
      <div class="xs:col-span-2 sm:col-span-2 xl:col-span-1 lg:col-span-1 md:col-span-1">
        <label>Sitio web</label>
        <input type="text" v-model="dato_contacto.sitio_web.value" placeholder="Direccion URL"
          @change="(setLocalStorage_(3), validData('sitio_web'))"
          class="block w-full py-1.5 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-300 focus:border-blue-500"
          :class="dato_contacto_props.sitio_web.state === true ? 'border-red-500' : ''" required />
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          v-if="dato_contacto_props.sitio_web.state === true">
          {{ dato_contacto_props.sitio_web.message }}
        </span>
      </div>
      <div class="grid grid-cols-2 col-span-2">
        <div class="">
          <label>Teléfonos</label>
          <input type="tel" v-model="numerosTelefono" placeholder="0000-0000" @change="setLocalStorage_(3)"
            maxlength="9" minlength="8" v-mask="maskTel"
            class="block w-full py-1.5 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-300 focus:border-blue-500"
            :class="dato_contacto.telefonos.state === true ? 'border-red-500' : ''" required />
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
            v-if="dato_contacto_props.telefonos.state === true">
            {{ dato_contacto_props.telefonos.message }}
          </span>
        </div>
        <div class="ml-3 mt-7">
          <button type="button" @click="addTelefono(null)"
            class="px-5 py-2 focus:outline-none text-white bg-blue-500 hover:bg-blue-600 rounded-md">
            <font-awesome-icon icon="plus" class="text-white"></font-awesome-icon>
            Agregar
          </button>
        </div>
      </div>
      <div class="xl:col-span-1 sm:col-span-2 md:col-span-2 xs:col-span-2 lg:col-span-2">
        <tablecomponent :items="dato_contacto.telefonos.value" :fields="fieldsNumerosTelefono">
          <template v-slot:accion="row">
            <button class="py-1 text-white bg-white focus:outline-none rounded-md"
              @click="addTelefono(row.item, row.item.id)">
              <font-awesome-icon icon="trash" class="text-primary"></font-awesome-icon>
            </button>
          </template>
        </tablecomponent>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { restrictDecimal } from "../../../plugins/shared";
import SelectComponent from "../../../components/SelectComponent";

export default {
  components: { SelectComponent },
  props: {
    informacion_empresa_props: null,

    ubicacion_props: null,
    dato_contacto_props: null,
  },
  data: () => ({
    maskTel: [/[267]/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    files: null,
    /*Generales*/
    telefono: null,
    numerosTelefono: null,
    modal: false,
    selected: '',
    maskara: null,

    /*Arrays con v-models del form*/
    informacion_empresa: {
      id_empresa: {
        value: null,
        state: null,
        message: 'Nombre de empresa es requerido *'
      },
      nombre_empresa: {
        value: null,
        state: null,
        message: 'Nombre de empresa es requerido *'
      },
      sales: {
        value: null,
        state: null,
        message: 'Rango de ventas del ultimo año es requerido *'
      },
      experiencia: {
        value: null,
        state: null,
        message: 'Experiencia es requerido *'
      },
      numero_registro: {
        value: null,
        state: null,
        message: 'Numero de registro es requerido *'
      },
      foto_numero_registro: {
        value: null,
        state: false,
        message: 'Escaneo numero de registro requerido *'
      },
      nombre_comercial_empresa: {
        value: null,
        state: null,
        message: 'nombre comercial es requerido *'
      },
      pais_origen_empresa: {
        value: 68,
        name: 'El Salvador',
        state: null,
        message: 'País de origen de la empresa es requerido *'
      },
      tipo_personeria: {
        value: null,
        state: null,
        name: null,
        message: 'Tipo de personería es requerido *'
      },
      numero_nit: {
        value: null,
        state: null,
        message: 'Numero de NIT es requerido *'
      },
      foto_nit: {
        value: null,
        state: false,
        message: 'Escaneo numero de NIT es requerido *'
      },
      tamano_empresa: {
        value: null,
        state: null,
        name: null,
        message: 'Clasificación de empresa es requerido *'
      },
      numero_matricula_comercial: {
        value: null,
        state: null,
        message: 'Numero de matricula comercial es requerido *'
      },
      foto_matricula_comercial: {
        value: null,
        state: false,
        message: 'Escaneo de matricula comercial es requerido *'
      },
      numero_iva: {
        value: null,
        state: null,
        message: 'Numero de iva es requerido *'
      },
      foto_iva: {
        value: null,
        state: null,
        message: 'Escaneo de iva es requerido *'
      },
      giros: {
        value: [],
        state: null,
        message: 'Giros de empresa es requerido *'
      },
    },
    ubicacion: {
      departamento: {
        value: 0,
        state: null,
        name: null,
        message: 'Departamento es requerido *'
      },
      municipio: {
        value: null,
        state: null,
        name: null,
        message: 'Municipio es requerido *'
      },
      direccion: {
        value: null,
        state: null,
        message: 'Direccion es requerido *'
      },
    },
    dato_contacto: {
      correo_empresa: {
        id: null,
        value: null,
        state: null,
        message: 'Correo electronico es requerido *'
      },
      telefonos: {
        value: [],
        state: null,
        message: 'Teléfonos de la empresa es requerido *'
      },
      sitio_web: {
        value: null,
        state: null,
        message: ''
      },
      isValidEmail: null,
      isValidEmailmessage: null,
    },

    /*Fields de tablas*/
    fieldsNumerosTelefono: [{ label: 'Teléfono', key: 'Telefono', class: 'text-center', }, {
      label: 'Acción',
      key: 'accion',
      class: 'text-center',
    }],

    fieldsGiro: [{ label: 'No.', key: 'No.', class: 'text-center' }, {
      label: 'Actividad o giro',
      key: 'Actividad o giro',
      class: 'text-center',
    }, { label: 'Acción', key: 'accion', class: 'text-center', }],

    /*Arrays para las opciones de los catalogos*/
    pais_origen_options: [],
    giro_options: [],
    tipo_personeria_options: [],
    departamento_options: [],
    municipio_options: [],
    clasificacion_empresa_options: [],
    tamano_empresa_options: [],
    InfoEmpresa: null,
    TipoPersona: null,

    /*Watchers*/
    departamento: null,
    giro: null,
    pais: 0,
    tamanio: 0,
    tipopersoneria: 0,
    municipio: null,
    fotonit: null,
    fotornc: null,
    matriculacomercial: null,
    idTipoPersona: null
  }),
  methods: {
    actualizarTipoPersona() {

      if(JSON.parse(window.localStorage.getItem('InfoEmpresas')).tipo_personeria){

        this.informacion_empresa.tipo_personeria.value = (JSON.parse(window.localStorage.getItem('InfoEmpresas')).tipo_personeria.value)
        this.tipopersoneria = (JSON.parse(window.localStorage.getItem('InfoEmpresas')).tipo_personeria.value)
      }
    },
    download(data) {
      console.log("entra a tratar de bajar doc")
      window.open(process.env.VUE_APP_API_URL + data + '?token=' + window.localStorage.getItem('token'), '_blank')
    },
    changeMask(e) {
      this.maskara = []
      if (e) {
        this.maskara.length = e.length + 1
        this.maskara.fill(/\d/)
        this.maskara[e.length - 2] = '-'
      }
    },
    validData(tipo) {
      switch (tipo) {
        case 'nombre_empresa':
          if (this.informacion_empresa.nombre_empresa.value !== null &&
            this.informacion_empresa.nombre_empresa.value !== '') {
            if (this.informacion_empresa.nombre_empresa.value.length > 100) {
              this.informacion_empresa_props.nombre_empresa.message = 'Debe de ingresar hasta 100 caracteres'
              this.informacion_empresa_props.nombre_empresa.state = true

            }
          }
          break
        case 'nombre_comercial_empresa':
          if (this.informacion_empresa.nombre_comercial_empresa.value !== null &&
            this.informacion_empresa.nombre_comercial_empresa.value !== '') {
            if (this.informacion_empresa.nombre_comercial_empresa.value.length > 100) {
              this.informacion_empresa_props.nombre_comercial_empresa.message = 'Debe de ingresar hasta 100 caracteres'
              this.informacion_empresa_props.nombre_comercial_empresa.state = true
            }
          }
          break
        case 'numero_matricula_comercial':
          if (this.informacion_empresa.numero_matricula_comercial.value !== null &&
            this.informacion_empresa.numero_matricula_comercial.value !== '') {
            if (this.informacion_empresa.numero_matricula_comercial.value.length > 50) {
              this.informacion_empresa_props.numero_matricula_comercial.message = 'Debe de ingresar hasta 50 caracteres'
              this.informacion_empresa_props.numero_matricula_comercial.state = true
            }
          }
          break
        case 'sales':
          if (this.informacion_empresa.sales.value !== null &&
            this.informacion_empresa.sales.value !== '' &&
            typeof (this.informacion_empresa.sales.value) !== 'undefined') {
            const re15Digit2Decimal = /^\d{0,15}(\.\d{0,2})?$/;
            if (!(re15Digit2Decimal.test(this.informacion_empresa.sales.value))) {
              this.informacion_empresa_props.sales.message = 'A excedido el valor máximo permitido'
              this.informacion_empresa_props.sales.state = true
            }
          }
          break
        case 'experiencia':
          if (this.informacion_empresa.experiencia.value !== null &&
            this.informacion_empresa.experiencia.value !== '') {
            const re4Digit = /^\d{0,4}?$/;
            if (!(re4Digit.test(this.informacion_empresa.experiencia.value))) {
              this.informacion_empresa_props.experiencia.message = 'A excedido el valor máximo permitido'
              this.informacion_empresa_props.experiencia.state = true
            }
          }
          break
        case 'direccion':
          if (this.ubicacion.direccion.value !== null &&
            this.ubicacion.direccion.value !== '') {
            if (this.ubicacion.direccion.value.length > 255) {
              this.ubicacion_props.direccion.message = 'Debe de ingresar hasta 255 caracteres'
              this.ubicacion_props.direccion.state = true
            }
          }
          break
        case 'correo_empresa':
          if (this.dato_contacto.correo_empresa.value !== null &&
            this.dato_contacto.correo_empresa.value !== '') {
            if (this.dato_contacto.correo_empresa.value.length > 100) {
              this.dato_contacto_props.correo_empresa.message = 'Debe de ingresar hasta 100 caracteres'
              this.dato_contacto_props.correo_empresa.state = true
            }
          }
          break
        case 'sitio_web':
          if (this.dato_contacto.sitio_web.value !== null &&
            this.dato_contacto.sitio_web.value !== '' &&
            typeof (this.dato_contacto.sitio_web.value) !== 'undefined') {
            if (this.dato_contacto.sitio_web.value.length > 100) {
              this.dato_contacto_props.sitio_web.message = 'Debe de ingresar hasta 100 caracteres'
              this.dato_contacto_props.sitio_web.state = true
            }
          }
          break
      }
    },
    isEmailValid() {
      let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      return (this.dato_contacto.correo_empresa.value === "" || this.dato_contacto.correo_empresa.value == null)
        ? "" : (reg.test(this.dato_contacto.correo_empresa.value))
          ? ('border-green-500', this.informacion_empresa.isValidEmail = true, this.informacion_empresa.isValidEmail === null
            ? '' : this.setLocalStorage_(1)) : ('border-red-300', this.informacion_empresa.isValidEmail = false,
              this.informacion_empresa.isValidEmailmessage = 'email invalido', this.setLocalStorage_(1));
    },
    verfile() {
    },
    fotornc_(foto) {
      const extensiones_permitidas = /(.jpg|.jpeg|.pdf)$/i
      if (!extensiones_permitidas.exec(foto.name) || (foto.size > 5242880)) {
        this.$toast.error('solo puedes subir archivos de formato jpg, jpeg y pdf máximo 5MB')
        this.fotornc = null
        this.fotoRnc = null
        this.$store.dispatch('Fodes/setDataFotos', { 'fotornc': [], 'tipo': 2 })
        this.informacion_empresa.foto_numero_registro.value = null
        window.localStorage.setItem('informacion_empresa', JSON.stringify(this.informacion_empresa))
        window.localStorage.setItem('foto_RNC', null)
        return false;
      } else {
        this.fotornc = foto.name
        this.$store.dispatch('Fodes/setDataFotos',
          { 'fotornc': foto, 'tipo': 2 })
        window.localStorage.setItem('ubicacion', JSON.stringify(this.ubicacion))
        this.informacion_empresa.foto_numero_registro.value = 'valor ingresado'
        window.localStorage.setItem('foto_RNC', foto.name)
      }
    },
    fotonit_(foto) {
      const extensiones_permitidas = /(.jpg|.jpeg|.pdf)$/i
      if (!extensiones_permitidas.exec(foto.name) || (foto.size > 5242880)) {
        this.$toast.error('solo puedes subir archivos de formato jpg, jpeg y pdf máximo 5MB')
        this.fotonit = null
        this.fotoNit = null
        this.$store.dispatch('Fodes/setDataFotos', { 'fotonit': [], 'tipo': 1 })
        this.informacion_empresa.foto_nit.value = null
        window.localStorage.setItem('informacion_empresa', JSON.stringify(this.informacion_empresa))
        window.localStorage.setItem('foto_NIT', null)
        return false;
      } else {
        this.fotonit = foto.name
        this.$store.dispatch('Fodes/setDataFotos', { 'fotonit': foto, 'tipo': 1 })
        this.informacion_empresa.foto_nit.value = 'valor ingresado'
        window.localStorage.setItem('informacion_empresa', JSON.stringify(this.informacion_empresa))
        window.localStorage.setItem('foto_NIT', foto.name)
      }
    },
    setLocalStorage_(tipo) {
      this.$store.dispatch('Fodes/setData',
        {
          'info_empresa': this.informacion_empresa, 'dato_contacto': this.dato_contacto, 'ubicacion': this.ubicacion,
          'tipo': tipo
        })
    },
    addTelefono(id, id_telefono) {
      if (id == null) {
        if (parseInt(this.numerosTelefono.charAt(0)) === 6 || parseInt(this.numerosTelefono.charAt(0)) === 7 || parseInt(this.numerosTelefono.charAt(0)) === 2) {
          if (this.dato_contacto.telefonos.value.length < 3) {
            if (this.numerosTelefono && this.numerosTelefono.trim() !== '' && this.numerosTelefono.trim().length >= 8
              && this.numerosTelefono.trim().length <= 9) {
              let cadena_a_comprobar = this.numerosTelefono
              let valoresAceptadosInt = /^[0-9]+$/;
              let valoresAceptadosGuion = /^\d{4}-\d{4}$/;
              if (cadena_a_comprobar.match(valoresAceptadosInt) || cadena_a_comprobar.match(valoresAceptadosGuion)) {
                let textoActual = this.numerosTelefono.trim();
                const isCelular = textoActual.length === 10 || textoActual.length === 11;
                let textoAjustado;
                textoAjustado = textoActual.replace(/\-/g, '');
                textoActual = textoAjustado;
                if (isCelular) {
                  const parte1 = textoActual.slice(0, 5);
                  const parte2 = textoActual.slice(5, 9);
                  textoAjustado = `${parte1}-${parte2}`
                } else {
                  const parte1 = textoActual.slice(0, 4);
                  const parte2 = textoActual.slice(4, 8);
                  textoAjustado = `${parte1}-${parte2}`
                }
                this.numerosTelefono = textoAjustado.trim();
                let arrTelefono = this.dato_contacto.telefonos.value

                if (arrTelefono.length === 0 && arrTelefono.length <= 1) {
                  this.dato_contacto.telefonos.value.push({ 'Telefono': this.numerosTelefono.replace(/ /g, "") })
                } else {
                  //this.dato_contacto.telefonos.value.push({'Telefono':this.numerosTelefono.replace(/ /g, "")})
                  let numeroExiste = arrTelefono.find(Telefono => Telefono.Telefono === this.numerosTelefono);
                  if (!numeroExiste) {
                    this.dato_contacto.telefonos.value.push({ 'Telefono': this.numerosTelefono.replace(/ /g, "") })
                  }
                }
                this.setLocalStorage_(3)
              } else {
              }
            }
          } else {
            this.$toast.error('Solo se permiten ingresar 3 números de teléfono')
            return false
          }
        } else {
          this.$toast.error('formato de telefono incorrecto')
        }
      } else {
        id_telefono > 0 ? this.deleteTelefonos(id_telefono) : ''
        this.dato_contacto.telefonos.value.splice(id.index, 1)
        this.setLocalStorage_(3)
        this.$store.dispatch('Fodes/setInfoEmpresa')
      }
      this.numerosTelefono = null
    },
    aggGiros(id, id_giro) {
      let arrGiro = this.informacion_empresa.giros.value
      if (id == null) {
        this.giro_options.forEach(row => {
          if (row.id === this.giro) {
            if (this.informacion_empresa.giros.value.length < 3) {
              let tipogiro = this.informacion_empresa.giros.value.length
              tipogiro = tipogiro + 1
              let number = 0
              this.informacion_empresa.giros.value.forEach(row => {
                number = number + 1
                if (row['No.'] !== number) {
                  tipogiro = number
                }
              })
              let giroExiste = arrGiro.find(Giros => Giros.id_giro === this.giro);
              if (!giroExiste) {
                this.informacion_empresa.giros.value.push({
                  'No.': tipogiro,
                  'Actividad o giro': row.nombre,
                  'id': row.id,
                  'id_giro': this.giro
                })
                this.setLocalStorage_(1)
              } else {
                this.$toast.warning('No se pueden agregar giros repetidos')
              }
              this.giro = null
            } else {
              this.$toast.error('Solo se permiten ingresar 3 tipos de giros')
              return false
            }
          }
        })
        return false
      } else {
        if (this.informacion_empresa.id_empresa.value) {
          axios.get(this.url + '/api/v1/empresas/' + this.informacion_empresa.id_empresa.value + '/giros',
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }).then((response) => {
              this.girosempresa = response.data
              if (this.girosempresa.find(Giro => Giro.id === id_giro)) {
                this.deleteGiros(id_giro)
              }
            });
        }
        this.informacion_empresa.giros.value.splice(id.index, 1)
        this.setLocalStorage_(1)
      }
      this.giro = null
    },
    deleteGiros(id) {
      if (id && this.informacion_empresa.id_empresa.value !== null && id !== '') {
        axios.delete(this.url + '/api/v1/empresas/' + this.informacion_empresa.id_empresa.value + '/giros/' + id).then((response) => {
          //this.informacion_empresa.giros.value.splice(index,position)
        });
      }
    },
    deleteTelefonos(id) {
      let headers = null
      if (this.$route.path.includes('/empresas/revision_informacion/')) {
        headers = { Authorization: 'Bearer ' + window.localStorage.getItem('token') }
      }
      if (this.informacion_empresa.id_empresa.value !== null) {
        axios.delete(this.url + '/api/v1/empresas/' + this.informacion_empresa.id_empresa.value + '/contactos/' + id, { headers }).then((response) => {
        });
      }
    },
    getDatosFormulario() {
      this.InfoEmpresa = JSON.parse(window.localStorage.getItem('InfoEmpresas'))
      let data = JSON.parse(window.localStorage.getItem('informacion_empresa'))
      let dataubicacion = JSON.parse(window.localStorage.getItem('ubicacion'))
      let datadato_contacto = JSON.parse(window.localStorage.getItem('dato_contacto'))

      if (this.InfoEmpresa) {
        this.informacion_empresa.numero_nit.value = this.InfoEmpresa.nit ? this.InfoEmpresa.nit : data.numero_nit.value
        this.informacion_empresa.numero_registro.value = this.InfoEmpresa.nrc
        this.informacion_empresa.nombre_empresa.value = this.InfoEmpresa.nombre_empresa ? this.InfoEmpresa.nombre_empresa : data.nombre_empresa.value
        this.InfoEmpresa.nombre_comercial !== null ? this.informacion_empresa.nombre_comercial_empresa.value = this.InfoEmpresa.nombre_comercial ? this.InfoEmpresa.nombre_comercial : data.nombre_comercial_empresa.value : this.informacion_empresa.nombre_comercial_empresa.value = null
        this.informacion_empresa.id_empresa.value = this.InfoEmpresa.id ? this.InfoEmpresa.id : null
        this.informacion_empresa.sales.value = this.InfoEmpresa.sales ? this.InfoEmpresa.sales : data.sales ? data.sales.value : null

        this.informacion_empresa.sales.value = this.InfoEmpresa.sales ? this.InfoEmpresa.sales : data.sales.value

        this.informacion_empresa.tamano_empresa.value = this.InfoEmpresa.id_tamanio_empresa ? this.InfoEmpresa.id_tamanio_empresa : data.tamano_empresa.value
        this.informacion_empresa.tamano_empresa.name = this.InfoEmpresa.nombre_tamanio_empresa ? this.InfoEmpresa.nombre_tamanio_empresa : data.tamano_empresa.name
        this.tamanio = this.InfoEmpresa.id_tamanio_empresa ? this.InfoEmpresa.id_tamanio_empresa : data.tamano_empresa.value
        this.tipopersoneria = this.InfoEmpresa.id_tipo_persona ? this.InfoEmpresa.id_tipo_persona : data.tipo_personeria.value
        // this.tipopersoneria = this.idTipoPersona
        this.informacion_empresa.tipo_personeria.value = this.InfoEmpresa.id_tipo_persona ? this.InfoEmpresa.id_tipo_persona : data.tipo_personeria.value
        this.informacion_empresa.tipo_personeria.name = this.InfoEmpresa.nombre_tipo_persona ? this.InfoEmpresa.nombre_tipo_persona : data.tipo_personeria.name

        this.informacion_empresa.numero_matricula_comercial.value = this.InfoEmpresa.matricula_comercial ? this.InfoEmpresa.matricula_comercial : data.numero_matricula_comercial.value

        this.pais = this.InfoEmpresa.id_pais
          ? this.InfoEmpresa.id_pais : data.pais_origen_empresa.value

        this.informacion_empresa.pais_origen_empresa.value = this.InfoEmpresa.id_pais
          ? this.InfoEmpresa.id_pais : data.pais_origen_empresa.value
        this.informacion_empresa.pais_origen_empresa.name = this.InfoEmpresa.nombre_nacionalidad
          ? this.InfoEmpresa.nombre_nacionalidad : data.pais_origen_empresa.name

        this.informacion_empresa.experiencia.value = this.InfoEmpresa.anios_experiencia ? this.InfoEmpresa.anios_experiencia : data.experiencia.value

        if (this.InfoEmpresa.id_departamento) {
          this.ubicacion.departamento.value = this.InfoEmpresa.id_departamento ? this.InfoEmpresa.id_departamento : dataubicacion.departamento.value
          this.ubicacion.departamento.name = this.InfoEmpresa.nombre_departamento ? this.InfoEmpresa.nombre_departamento : dataubicacion.departamento.name
          this.departamento = this.InfoEmpresa.id_departamento ? this.InfoEmpresa.id_departamento : dataubicacion.departamento.value
        }
        if (this.InfoEmpresa.id_municipio) {
          this.ubicacion.municipio.value = this.InfoEmpresa.id_municipio ? this.InfoEmpresa.id_municipio : dataubicacion.municipio.value
          this.ubicacion.municipio.name = this.InfoEmpresa.nombre_municipio ? this.InfoEmpresa.nombre_municipio : dataubicacion.municipio.name
          this.municipio = this.InfoEmpresa.id_municipio ? this.InfoEmpresa.id_municipio : dataubicacion.municipio.value
        }
        if (this.InfoEmpresa.direccion) {
          this.ubicacion.direccion.value = this.InfoEmpresa.direccion ? this.InfoEmpresa.direccion : data.numero_matricula_comercial.value
        }

        this.informacion_empresa.foto_nit.value = this.InfoEmpresa.nit_doc ? this.InfoEmpresa.nit_doc : null
        this.informacion_empresa.foto_nit.value !== null && this.informacion_empresa.foto_nit.value.length !== 0
          ? this.$store.dispatch('Fodes/setDataFotos', {
            'fotonit': this.informacion_empresa.foto_nit.value,
            'tipo': 1
          }) : false

        this.informacion_empresa.foto_numero_registro.value = this.InfoEmpresa.nrc_doc ? this.InfoEmpresa.nrc_doc : null
        this.informacion_empresa.foto_numero_registro.value !== null && this.informacion_empresa.foto_numero_registro.value.length !== 0
          ? this.$store.dispatch('Fodes/setDataFotos', {
            'fotornc': this.informacion_empresa.foto_numero_registro.value,
            'tipo': 2
          }) : false

        this.dato_contacto.sitio_web.value = this.InfoEmpresa.sitio_web ? this.InfoEmpresa.sitio_web : null

        if (typeof (this.dato_contacto.sitio_web.value) === 'undefined') this.dato_contacto.sitio_web.value = null

        if (datadato_contacto) {
          if (datadato_contacto.sitio_web.value !== null) {
            this.dato_contacto.sitio_web.value = datadato_contacto.sitio_web.value
          } else if (this.InfoEmpresa.sitio_web !== null && typeof (this.InfoEmpresa.sitio_web) !== 'undefined') {
            this.dato_contacto.sitio_web.value = this.InfoEmpresa.sitio_web
          }
        }

        if (this.InfoEmpresa.anios_experiencia) {
          this.informacion_empresa.experiencia.value = this.InfoEmpresa.anios_experiencia
        } else if (data) {
          this.informacion_empresa.experiencia.value = data.experiencia.value
        } else {
          this.informacion_empresa.experiencia.value = 0
        }


        if (data) {
          if (data.giros.value.length > 0) {
            this.informacion_empresa.giros.value = data.giros.value
          }
        }

        if (this.InfoEmpresa.id) {
          this.getGirosToEmpresa(this.InfoEmpresa.id)
        }

        if (this.InfoEmpresa.contactos) {
          let arrCorreo = this.InfoEmpresa.contactos
          arrCorreo.forEach(row => {
            if (row.id_tipo_contacto === 2) {
              //this.dato_contacto.correo_empresa.value = row.contacto
              this.dato_contacto.correo_empresa.value = row.contacto
              this.dato_contacto.correo_empresa.id = row.id
              window.localStorage.setItem('dato_contacto', JSON.stringify(this.dato_contacto))
            } else if (row.id_tipo_contacto === 1) {
              this.dato_contacto.telefonos.value.push({ 'Telefono': row.contacto, 'id': row.id })
              window.localStorage.setItem('dato_contacto', JSON.stringify(this.dato_contacto))
            }
          })
        } else {
          if (datadato_contacto) {
            if (datadato_contacto.correo_empresa && !this.InfoEmpresa.contactos) {
              if (datadato_contacto.correo_empresa.value !== null) {
                this.dato_contacto.correo_empresa.value = datadato_contacto.correo_empresa.value
              }
            }
          }
        }

        if (datadato_contacto) {
          if (datadato_contacto.telefonos) {
            if (datadato_contacto.telefonos.value.length) {
              if (datadato_contacto.telefonos.value.length !== 0) {
                this.dato_contacto.telefonos.value = datadato_contacto.telefonos.value
              }
            }
          }
        }

        if (data) {
          this.informacion_empresa.isValidEmail = data.isValidEmail
        }
        // ValidData
        if (this.informacion_empresa.nombre_empresa.value !== null &&
          this.informacion_empresa.nombre_empresa.value !== '') {
          if (this.informacion_empresa.nombre_empresa.value.length > 100) {
            this.informacion_empresa.nombre_empresa.message = 'Debe de ingresar hasta 100 caracteres'
            this.informacion_empresa.nombre_empresa.state = true
          }
        }
        if (this.informacion_empresa.nombre_comercial_empresa.value !== null &&
          this.informacion_empresa.nombre_comercial_empresa.value !== '') {
          if (this.informacion_empresa.nombre_comercial_empresa.value.length > 100) {
            this.informacion_empresa.nombre_comercial_empresa.message = 'Debe de ingresar hasta 100 caracteres'
            this.informacion_empresa.nombre_comercial_empresa.state = true
          }
        }
        if (this.informacion_empresa.numero_matricula_comercial.value !== null &&
          this.informacion_empresa.numero_matricula_comercial.value !== '') {
          if (this.informacion_empresa.numero_matricula_comercial.value.length > 50) {
            this.informacion_empresa.numero_matricula_comercial.message = 'Debe de ingresar hasta 50 caracteres'
            this.informacion_empresa.numero_matricula_comercial.state = true
          }
        }
        if (this.informacion_empresa.sales.value !== null &&
          this.informacion_empresa.sales.value !== '' &&
          typeof (this.informacion_empresa.sales.value) !== 'undefined') {
          let re15Digit2Decimal = /^\d{0,15}(\.\d{0,2})?$/;
          if (!(re15Digit2Decimal.test(this.informacion_empresa.sales.value))) {
            this.informacion_empresa.sales.message = 'A excedido el valor máximo permitido'
            this.informacion_empresa.sales.state = true
          }
        }
        if (this.informacion_empresa.experiencia.value !== null &&
          this.informacion_empresa.experiencia.value !== '') {
          let re4Digit = /^\d{0,4}?$/;
          if (!(re4Digit.test(this.informacion_empresa.experiencia.value))) {
            this.informacion_empresa.experiencia.message = 'A excedido el valor máximo permitido'
            this.informacion_empresa.experiencia.state = true
          }
        }
        if (this.ubicacion.direccion.value !== null &&
          this.ubicacion.direccion.value !== '') {
          if (this.ubicacion.direccion.value.length > 255) {
            this.ubicacion.direccion.message = 'Debe de ingresar hasta 255 caracteres'
            this.ubicacion.direccion.state = true
          }
        }
        if (this.dato_contacto.correo_empresa.value !== null &&
          this.dato_contacto.correo_empresa.value !== '') {
          if (this.dato_contacto.correo_empresa.value.length > 100) {
            this.dato_contacto.correo_empresa.message = 'Debe de ingresar hasta 100 caracteres'
            this.dato_contacto.correo_empresa.state = true
          }
        }
        if (this.dato_contacto.sitio_web.value !== null &&
          this.dato_contacto.sitio_web.value !== '' &&
          typeof (this.dato_contacto.sitio_web.value) !== 'undefined') {
          if (this.dato_contacto.sitio_web.value.length > 100) {
            this.dato_contacto.sitio_web.message = 'Debe de ingresar hasta 100 caracteres'
            this.dato_contacto.sitio_web.state = true
          }
        }
        this.setLocalStorage_(1)
        this.setLocalStorage_(2)
        this.setLocalStorage_(3)
      }
      if (this.DataFormulario.ubicacion.length !== 0) {
        this.ubicacion = this.DataFormulario.ubicacion
      }
      if (this.DataFormulario.dato_contacto.length !== 0) {
        this.dato_contacto = this.DataFormulario.dato_contacto
      }

    },
    getMunicipios(id_departamento) {
      this.ubicacion.departamento.value = id_departamento
      axios.get(this.url + '/api/v1/municipios?id_departamento=' + id_departamento,
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }).then((response) => {
          this.municipio_options = response.data
        });
    },
    getDepartamentos() {
      axios.get(this.url + '/api/v1/departamentos?id_pais=' + 68,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then((response) => {
          this.departamento_options = response.data
        });
    },
    getPaises() {
      axios.get(this.url + '/api/v1/paises',
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }).then((response) => {
          this.pais_origen_options = response.data
        });
    },
    getEmpresasTamanios() {
      axios.get(this.url + '/api/v1/empresas/tamanios',
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }).then((response) => {
          this.tamano_empresa_options = response.data
        });
    },
    getEmpresasGiro() {
      this.InfoEmpresa = JSON.parse(window.localStorage.getItem('InfoEmpresas'))

      axios.get(this.url + '/api/v1/empresas/giros/' + this.InfoEmpresa.tipoEmpresa,
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }).then((response) => {

          this.giro_options = response.data
        });
    },

    getEmpresasPersonerias() {
      axios.get(this.url + '/api/v1/empresas/personerias',
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }).then((response) => {
          this.tipo_personeria_options = response.data
        });
    },
    getGirosToEmpresa(id) {
      let token
      if (window.localStorage.getItem('token') && this.$route.name !== 'empresa_registro') {
        token = 'Bearer ' + window.localStorage.getItem('token')
      } else {
        token = null
      }
      if (id > 0) {
        axios.get(this.url + '/api/v1/empresas/' + id + '/giros',
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': token
            }
          }).then((response) => {
            let DataGirosTable = []
            response.data.forEach(row => {
              if (this.informacion_empresa.giros.value !== null) {
                DataGirosTable.push({
                  'No.': row.id_tipo_giro,
                  'Actividad o giro': row.nombre_giro,
                  'id': row.id,
                  'id_giro': row.id_giro
                })
              }
            })
            this.informacion_empresa.giros.value = DataGirosTable.sort(function (a, b) {
              return a['No.'] - b['No.']
            })
            this.informacion_empresa_props.giros.value = response.data
            if (this.$route.path.includes('/empresas/revision')) {
              if (this.informacion_empresa_props.giros.value.length > 0) {
                this.informacion_empresa_props.giros.state = false
              }
            }
            this.setLocalStorage_(1)
          });
      }
    },
    seteoData() {
      if (this.informacion_empresa.pais_origen_empresa.value == null || this.informacion_empresa.pais_origen_empresa.value === 0
        || this.informacion_empresa.pais_origen_empresa.value === '' || this.pais === 0) {
        this.pais = 68
        this.informacion_empresa.pais_origen_empresa.value = 68
        this.setLocalStorage_(1)
      }
    },
    restrictDecimal(val) {
      return restrictDecimal(val)
    }
  },
  computed: {
    ...mapGetters({
      DataFormulario: "Fodes/getLocalStorage_",
      url: "getURL",
      fotoNit: 'Fodes/getFotoNit',
      fotoRnc: 'Fodes/getFotoRnc',
    }),
    correo_empresa() {
      return this.dato_contacto.correo_empresa.value
    },
    requiredLicense() {
      return this.informacion_empresa.tipo_personeria.value === 1 ? '' : '*'
    },
}
  ,
  created() {
    this.seteoData()
    this.getDepartamentos()
    this.getPaises()
    this.getEmpresasTamanios()
    this.getEmpresasGiro()
    this.getEmpresasPersonerias()        
    this.getDatosFormulario()
    this.verfile()
    this.actualizarTipoPersona()

  },
  watch: {
    pais() {
      if (this.pais !== null && this.pais !== '' && this.pais !== 0 && this.pais !== null) {
        this.informacion_empresa.pais_origen_empresa.value = this.pais
        this.setLocalStorage_(1)
      }
    },
    numerosTelefono: function (val) {
      if (val !== null) {
      }
    },
    departamento: function (val) {
      if (val !== null) {
        let deptoArray = this.departamento_options
        deptoArray.forEach(row => {
          if (row.id === val) {
            this.ubicacion.departamento.value = row.id
            this.ubicacion.departamento.name = row.nombre
            this.departamento = row.id
          } else {
            this.municipio = null
            this.ubicacion.municipio.name = null
            this.ubicacion.municipio.value = null
          }
        })
        let municipioLocalStorage = JSON.parse(window.localStorage.getItem('ubicacion'))
        if (municipioLocalStorage.municipio.value < 0 || municipioLocalStorage.municipio.value == null) {
          this.ubicacion.municipio.value = null
          this.ubicacion.municipio.name = null
          this.municipio = null
          this.municipio_options = []
        }
        this.setLocalStorage_(2)
        this.getMunicipios(val)
        this.setLocalStorage_(2)
      } else {
        this.ubicacion.departamento.value = null
        this.ubicacion.departamento.name = null
        this.departamento = null
        this.municipio_options = []
        this.municipio = null
        this.ubicacion.municipio.name = null
        this.ubicacion.municipio.value = null
        this.setLocalStorage_(2)
      }
    },
    municipio: function (val) {
      if (val !== null) {
        let municipioArray = this.municipio_options
        if (municipioArray !== null) {
          municipioArray.forEach(row => {
            if (row.id === val) {
              this.ubicacion.municipio.value = row.id
              this.ubicacion.municipio.name = row.nombre
              this.municipio = row.id
            }
          })
        }
        this.setLocalStorage_(2)
      } else {
        this.ubicacion.municipio.value = null
        this.ubicacion.municipio.name = null
        this.municipio = null
        this.ubicacion_props.municipio.state = null
      }
    },
    tipopersoneria: function (val) {
      //if (val !== null) {
      this.informacion_empresa.tipo_personeria.value = val
      this.setLocalStorage_(1)
      //}
    },
    tamanio: function (val) {
      if (val !== null) {
        let tamanioArray = this.tamano_empresa_options
        tamanioArray.forEach(row => {
          if (row.id === val) {
            this.informacion_empresa.tamano_empresa.value = row.id
            this.informacion_empresa.tamano_empresa.name = row.nombre
            this.tamanio = row.id
            this.setLocalStorage_(1)
          }
        })
      } else {
        this.informacion_empresa.tamano_empresa.value = null
        this.informacion_empresa.tamano_empresa.name = null
        this.tamanio = null
        this.setLocalStorage_(1)
      }
    },
  },
}

</script>
